export const LOADING_SPINNER = "loading spinner";
